import { Variants } from 'framer-motion';

export const dashboardContainerVariant: Variants = {
  hidden: {
    scale: 0,
    y: '100vh',
    position: 'absolute',
  },
  show: {
    scale: 1,
    y: 0,
    position: 'static',
    opacity: 1,
    transition: {
      type: 'spring',
      damping: 20,
      stiffness: 100,
      staggerChildren: 0.15,
    },
  },
  exit: {
    position: 'absolute',
    scale: 0,
    y: 0,
    opacity: 0,
    transition: {
      type: 'spring',
      damping: 20,
      stiffness: 100,
    },
  },
};

export const dashboardCardVariant: Variants = {
  hidden: {
    opacity: 0,
    scale: 0,
    y: 20,
  },
  show: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: 'spring',
      damping: 20,
      stiffness: 100,
    },
  },
};

export const dialogDimVariant: Variants = {
  hidden: {
    opacity: 0,
  },
  show: {
    opacity: 1,
  },
  exit: {
    opacity: 0,
  },
};

export const dialogCardVariant: Variants = {
  hidden: {
    scale: 0.9,
  },
  show: {
    scale: 1,
  },
  exit: {
    scale: 0.9,
  },
};

export const dialogActionVariant: Variants = {
  hidden: {
    position: 'absolute',
    opacity: 0,
    x: '100%',
    scaleY: 0.9,
  },
  show: {
    position: 'relative',
    opacity: 1,
    x: 0,
    scaleY: 1,
  },
  exit: {
    position: 'absolute',
    opacity: 0,
    x: '-100%',
    scaleY: 0.9,
  },
};
